var map = {
	"./active_material/icons/account_circle": 11,
	"./active_material/icons/account_circle.svg": 11,
	"./active_material/icons/arrow-dropdown": 8,
	"./active_material/icons/arrow-dropdown.svg": 8,
	"./active_material/icons/arrow_down": 16,
	"./active_material/icons/arrow_down.svg": 16,
	"./active_material/icons/clear": 12,
	"./active_material/icons/clear.svg": 12,
	"./active_material/icons/create": 17,
	"./active_material/icons/create.svg": 17,
	"./active_material/icons/email": 13,
	"./active_material/icons/email.svg": 13,
	"./active_material/icons/event": 9,
	"./active_material/icons/event.svg": 9,
	"./active_material/icons/more": 15,
	"./active_material/icons/more.svg": 15,
	"./active_material/icons/reorder": 10,
	"./active_material/icons/reorder.svg": 10,
	"./active_material/icons/search": 18,
	"./active_material/icons/search.svg": 18,
	"./active_material/icons/secret": 14,
	"./active_material/icons/secret.svg": 14,
	"./cc-4-by": 59,
	"./cc-4-by.png": 59,
	"./logo": 60,
	"./logo.png": 60,
	"./logo_dots": 61,
	"./logo_dots.png": 61,
	"./logo_slide": 62,
	"./logo_slide.png": 62,
	"./orcid_id": 63,
	"./orcid_id.svg": 63,
	"./slide_1": 64,
	"./slide_1.png": 64,
	"./slide_2": 65,
	"./slide_2.png": 65,
	"./slide_3": 66,
	"./slide_3.png": 66,
	"./slide_4": 67,
	"./slide_4.png": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;